import { reactive } from "vue"
import { SignupFields, SignupErrors } from "@/components/login/desktop/types"
import { UserData } from "@/store/types"

enum ActiveComponents {
  StartAuthorize = "StartAuthorize",
  Authorize = "Authorize",
}

const state = reactive({
  activeComponent:
    ActiveComponents.StartAuthorize as keyof typeof ActiveComponents,
  description: "",
  fields: {
    username: "",
    password: "",
    passwordConfirmation: "",
  } as SignupFields,
  terms_and_policy: false,
  copied: false,
  errors: {
    username: [],
    phrase: [],
  } as SignupErrors,
  referral: null as UserData | null,
})

export function useLoginState() {
  return { state }
}
